
class Select {
    constructor(target, init) {
        this.select = $(target);
        this.list = this.select.find('.select__list');
        this.listsBtn = this.list.find('a');
        this.openBtn = this.select.find('.select__open');
        this.cons = this.select.find('.select__con');
        this.dom = {
            now: -1
        }

        this.bindEvent();
        if( init ) this.init();
    }

    init(){
        this.action.call( this, this.list.find('[data-game-code="lin"]') );
    }


    get now() {
        return this.dom.now;
    }

    on(e, eventListener) {
        this.listsBtn.on( e, () =>{
            eventListener({now: this.now});
        })
    }

    action(t) {
        this.list.hide();
        this.openBtn.text( t.text() );
        this.dom.now = t.closest('li').index();
        if( this.cons.length ){
            let con = this.select.find(`.select__con--${t.data().gameCode}`);
            this.cons.removeClass('show');
            con.addClass('show');
        }
    }


    bindEvent() {
        this.openBtn.on('click', ()=> this.list.is(':visible') ? this.list.hide() : this.list.show() );
        this.listsBtn.on('click', (e)=> this.action($(e.target)) );
    }
}

export default Select


// WEBPACK FOOTER //
// ./src/js/_selectBox.js